import React, { useState, useEffect } from 'react'
import { Typography } from '@mui/material'
import PhotoAlbum from './portfolio/PhotoAlbum'
import { getHouses } from './api'

function Portfolio() {
  const [houses, setHouses] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getHouses()
      .then(setHouses)
      .finally(() => setLoading(false))
  }, [])

  if (loading) {
    return (
      <div style={{ padding: '80px', textAlign: 'center' }}>
        <Typography variant="h6" color="textSecondary">Loading...</Typography>
      </div>
    )
  }

  return (
    <div>
      {houses.map((house, i) => (
        <PhotoAlbum
          key={house.id}
          images={house.preview_images?.length ? house.preview_images : [house.cover_image].filter(Boolean)}
          buttonText={house.name}
          buttonLink={`/portfolio/${house.id}`}
          slideSide={i % 2 === 0 ? 'left' : 'right'}
        />
      ))}
    </div>
  )
}

export default Portfolio
